(function (t) {
// hu
t.add("label_previous", "El\u0151z\u0151", "KnpPaginatorBundle", "hu");
t.add("label_next", "K\u00f6vetkez\u0151", "KnpPaginatorBundle", "hu");
})(Translator);
